export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const WEBSITE_URL = process.env.NEXT_PUBLIC_DEPLOY_URL;
export const POPULAR_ADRESS_ID_1 = 1;
export const POPULAR_ADRESS_ID_2 = 79;
export const POPULAR_ADRESS_ID_3 = 48;
export const URL_BLOG = process.env.NEXT_PUBLIC_URL_BLOG;
export const FACEBOOK_APP_ID = "915263896752397";
export const FALLBACK =
  "data:image/png;base64,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";

export const IMAGE_TYPE = {
  avatar: "AVATAR",
  banner: "BANNER",
  introduce: "INTRODUCE",
};

export const STROKE_COLOR = "#00C5D7";
export const TRAIL_COLOR = "#BCF5FF";

export const TOP_PROVINCE = [
  {
    key: "1",
    label: <h3>Hà Nội</h3>,
    name: "Hà Nội",
  },
  {
    key: "31",
    label: <h3>Hải Phòng</h3>,
    name: "Hải Phòng",
  },
  {
    key: "48",
    label: <h3>Đà Nẵng</h3>,
    name: "Đà Nẵng",
  },
  {
    key: "79",
    label: <h3>Tp. Hồ Chí Minh</h3>,
    name: "Tp. Hồ Chí Minh",
  },
];

export const TOP_PROVINCE_HOT = [
  {
    key: "hanoi",
    label: <h3>Hà Nội</h3>,
    name: "Hà Nội",
  },
  // {
  //   key: "48",
  //   label: <h3>Đà Nẵng</h3>,
  //   name: "Đà Nẵng",
  // },
  {
    key: "hcm",
    label: <h3>Tp. Hồ Chí Minh</h3>,
    name: "Tp. Hồ Chí Minh",
  },
];

export const REGION_TAG_FOR_REMARKABLE = [
  {
    key: "north",
    label: <h3>Miền Bắc</h3>,
    name: "Miền Bắc",
  },

  {
    key: "middle",
    label: <h3>Miền Trung</h3>,
    name: "Miền Trung",
  },
  {
    key: "south",
    label: <h3>Miền Nam</h3>,
    name: "Miền Nam",
  },
];

export const CATEGORY_SERVICE = [
  {
    id: 147483649,
    name: "Niềng răng",
    link: require("@/public/image/nieng-rang-tham-my.svg"),
  },
  {
    id: 147483647,
    name: "Bọc răng sứ",
    link: require("@/public/image/boc-rang-su.svg"),
  },
  {
    id: 147483650,
    name: "Trồng răng Implant",
    link: require("@/public/image/trong-rang-implant.svg"),
  },
  {
    id: 147483648,
    name: "Dán răng sứ",
    link: require("@/public/image/dan-rang-su.svg"),
  },
];

export const PRICE_FILTER = [
  { name: "Dưới 1 triệu", max: 1 },
  { name: "1 - 3 triệu", min: 1, max: 3 },
  { name: "3 - 5 triệu", min: 3, max: 5 },
  { name: "5 - 7 triệu", min: 5, max: 7 },
  { name: "Trên 7 triệu", min: 7 },
];

export const PRICE_FILTER_SERVICE = [
  {
    id: 147483647,
    price: [
      {
        name: "Dưới 2 triệu",
        // min: 1,
        max: 2,
      },
      {
        name: "2 - 4 triệu",
        min: 2,
        max: 4,
      },
      {
        name: "4 - 6 triệu",
        min: 4,
        max: 6,
      },
      {
        name: "6 - 8 triệu",
        min: 6,
        max: 8,
      },
      {
        name: "Trên 8 triệu",
        min: 8,
      },
    ],
  },
  {
    id: 147483648,
    price: [
      {
        name: "Dưới 2 triệu",
        // min: 1,
        max: 2,
      },
      {
        name: "2 - 4 triệu",
        min: 2,
        max: 4,
      },
      {
        name: "4 - 6 triệu",
        min: 4,
        max: 6,
      },
      {
        name: "6 - 8 triệu",
        min: 6,
        max: 8,
      },
      {
        name: "Trên 8 triệu",
        min: 8,
      },
    ],
  },
  {
    id: 147483649,
    price: [
      {
        name: "Dưới 30 triệu",
        max: 30,
      },
      {
        name: "30 - 50 triệu",
        min: 30,
        max: 50,
      },
      {
        name: "50 - 80 triệu",
        min: 50,
        max: 80,
      },
      {
        name: "Trên 80 triệu",
        min: 80,
      },
    ],
  },
  {
    id: 147483650,
    price: [
      {
        name: "Dưới 10 triệu",
        max: 10,
      },
      {
        name: "10 - 20 triệu",
        min: 10,
        max: 20,
      },
      {
        name: "20 - 35 triệu",
        min: 20,
        max: 35,
      },
      {
        name: "Trên 35 triệu",
        min: 35,
      },
    ],
  },
  {
    id: 147483651,
    price: [
      {
        name: "Dưới 1 triệu",
        max: 1,
      },
      {
        name: "1 - 2 triệu",
        min: 1,
        max: 2,
      },
      {
        name: "Trên 2 triệu",
        min: 2,
      },
    ],
  },
  {
    id: 147483652,
    price: [
      {
        name: "Dưới 300 nghìn",
        max: 0.3,
      },
      {
        name: "300 - 700 nghìn",
        min: 0.3,
        max: 0.7,
      },
      {
        name: "Trên 700 nghìn",
        min: 0.7,
      },
    ],
  },
  // {
  //   id: 147483653,
  //   price: [
  //     {
  //       name: "Dưới 1 triệu",
  //       max: 1,
  //     },
  //     {
  //       name: "1 đến 2 triệu",
  //       min: 1,
  //       max: 2,
  //     },
  //     {
  //       name: "Trên 2 triệu",
  //       min: 2,
  //     },
  //   ],
  // },
  // {
  //   id: 147483654,
  //   price: [
  //     {
  //       name: "Dưới 1 triệu",
  //       max: 1,
  //     },
  //     {
  //       name: "1 đến 2 triệu",
  //       min: 1,
  //       max: 2,
  //     },
  //     {
  //       name: "Trên 2 triệu",
  //       min: 2,
  //     },
  //   ],
  // },
  // {
  //   id: 147483655,
  //   price: [
  //     {
  //       name: "Dưới 1 triệu",
  //       max: 1,
  //     },
  //     {
  //       name: "1 đến 2 triệu",
  //       min: 1,
  //       max: 2,
  //     },
  //     {
  //       name: "Trên 2 triệu",
  //       min: 2,
  //     },
  //   ],
  // },
  // {
  //   id: 147483656,
  //   price: [
  //     {
  //       name: "Dưới 1 triệu",
  //       max: 1,
  //     },
  //     {
  //       name: "1 đến 2 triệu",
  //       min: 1,
  //       max: 2,
  //     },
  //     {
  //       name: "Trên 2 triệu",
  //       min: 2,
  //     },
  //   ],
  // },
];

export const PREFIX_IMAGE_URL = process.env.NEXT_PUBLIC_PREFIX_IMAGE;
export const REVIEW_DENTISTRY = [
  {
    id: 1,
    image: "",
    blog: "KIẾN THỨC TRỒNG RĂNG",
    title: "Trồng Răng Hàm Giá Bao Nhiêu? Có Đau Không Và Lưu Ý",
    content:
      "Các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà. Chúng chủ yếu được bào chế từ các, các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà  ",
  },
  {
    id: 2,
    image: "",
    blog: "KIẾN THỨC TRỒNG RĂNG",
    title: "Niềng Răng Có Đau Không? Đau Bao Lâu? 1",
    content:
      "Các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà. Chúng chủ yếu được bào chế từ các, các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà  ",
  },
  {
    id: 3,
    image: "",
    blog: "KIẾN THỨC TRỒNG RĂNG",
    title: "Niềng Răng Có Đau Không? Đau Bao Lâu? 2",
    content:
      "Các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà. Chúng chủ yếu được bào chế từ các, các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà  ",
  },
  {
    id: 4,
    image: "",
    blog: "KIẾN THỨC TRỒNG RĂNG",
    title: "Niềng Răng Có Đau Không? Đau Bao Lâu? 3",
    content:
      "Các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà. Chúng chủ yếu được bào chế từ các, các bài thuốc dân gian chữa viêm khớp cùng chậu được nhiều bệnh nhân áp dụng để khắc phục bệnh tại nhà  ",
  },
];

export const REVALIDATE = 3600;

export const LIST_WEEKDAY = [
  {
    id: 2,
    name: "Thứ 2",
  },
  {
    id: 3,
    name: "Thứ 3",
  },
  {
    id: 4,
    name: "Thứ 4",
  },
  {
    id: 5,
    name: "Thứ 5",
  },
  {
    id: 6,
    name: "Thứ 6",
  },
  {
    id: 7,
    name: "Thứ 7",
  },
  {
    id: 8,
    name: "Chủ Nhật",
  },
];

export const POPULAR_ADRESS_1 = [
  {
    id: 1,
    name: "Ba Đình",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:42.975Z",
    updated_at: "2024-01-28T17:20:42.975Z",
  },
  {
    id: 2,
    name: "Hoàn Kiếm",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:42.991Z",
    updated_at: "2024-01-28T17:20:42.991Z",
  },
  {
    id: 3,
    name: "Tây Hồ",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.003Z",
    updated_at: "2024-01-28T17:20:43.003Z",
  },
  {
    id: 4,
    name: "Long Biên",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.016Z",
    updated_at: "2024-01-28T17:20:43.016Z",
  },
  {
    id: 5,
    name: "Cầu Giấy",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.033Z",
    updated_at: "2024-01-28T17:20:43.033Z",
  },
  {
    id: 6,
    name: "Đống Đa",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.046Z",
    updated_at: "2024-01-28T17:20:43.046Z",
  },
  {
    id: 7,
    name: "Hai Bà Trưng",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.060Z",
    updated_at: "2024-01-28T17:20:43.060Z",
  },
  {
    id: 8,
    name: "Hoàng Mai",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.076Z",
    updated_at: "2024-01-28T17:20:43.076Z",
  },
  {
    id: 9,
    name: "Thanh Xuân",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.087Z",
    updated_at: "2024-01-28T17:20:43.087Z",
  },
  {
    id: 19,
    name: "Nam Từ Liêm",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.143Z",
    updated_at: "2024-01-28T17:20:43.143Z",
  },
  {
    id: 20,
    name: "Thanh Trì",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.155Z",
    updated_at: "2024-01-28T17:20:43.155Z",
  },
  {
    id: 21,
    name: "Bắc Từ Liêm",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.168Z",
    updated_at: "2024-01-28T17:20:43.168Z",
  },
  {
    id: 250,
    name: "Mê Linh",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.184Z",
    updated_at: "2024-01-28T17:20:43.184Z",
  },
  {
    id: 268,
    name: "Hà Đông",
    province_id: 1,
    popular: true,
    created_at: "2024-01-28T17:20:43.196Z",
    updated_at: "2024-01-28T17:20:43.196Z",
  },
];

export const POPULAR_ADRESS_2 = [
  {
    id: 760,
    name: "Quận 1",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.798Z",
    updated_at: "2024-01-28T17:20:50.798Z",
  },
  {
    id: 761,
    name: "Quận 12",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.811Z",
    updated_at: "2024-01-28T17:20:50.811Z",
  },
  {
    id: 764,
    name: "Gò Vấp",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.822Z",
    updated_at: "2024-01-28T17:20:50.822Z",
  },
  {
    id: 765,
    name: "Bình Thạnh",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.838Z",
    updated_at: "2024-01-28T17:20:50.838Z",
  },
  {
    id: 766,
    name: "Tân Bình",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.850Z",
    updated_at: "2024-01-28T17:20:50.850Z",
  },
  {
    id: 767,
    name: "Tân Phú",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.864Z",
    updated_at: "2024-01-28T17:20:50.864Z",
  },
  {
    id: 768,
    name: "Phú Nhuận",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.878Z",
    updated_at: "2024-01-28T17:20:50.878Z",
  },
  {
    id: 769,
    name: "Thủ Đức",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.892Z",
    updated_at: "2024-01-28T17:20:50.892Z",
  },
  {
    id: 770,
    name: "Quận 3",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.905Z",
    updated_at: "2024-01-28T17:20:50.905Z",
  },
  {
    id: 771,
    name: "Quận 10",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.920Z",
    updated_at: "2024-01-28T17:20:50.920Z",
  },
  {
    id: 772,
    name: "Quận 11",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.932Z",
    updated_at: "2024-01-28T17:20:50.932Z",
  },
  {
    id: 773,
    name: "Quận 4",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.946Z",
    updated_at: "2024-01-28T17:20:50.946Z",
  },
  {
    id: 774,
    name: "Quận 5",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.958Z",
    updated_at: "2024-01-28T17:20:50.958Z",
  },
  {
    id: 775,
    name: "Quận 6",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.972Z",
    updated_at: "2024-01-28T17:20:50.972Z",
  },
  {
    id: 776,
    name: "Quận 8",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:50.988Z",
    updated_at: "2024-01-28T17:20:50.988Z",
  },
  {
    id: 777,
    name: "Bình Tân",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:51.002Z",
    updated_at: "2024-01-28T17:20:51.002Z",
  },
  {
    id: 778,
    name: "Quận 7",
    province_id: 79,
    popular: true,
    created_at: "2024-01-28T17:20:51.019Z",
    updated_at: "2024-01-28T17:20:51.019Z",
  },
];
export const POPULAR_ADRESS_3 = [
  {
    id: 490,
    name: "Liên Chiểu",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.882Z",
    updated_at: "2024-01-28T17:20:47.882Z",
  },
  {
    id: 491,
    name: "Thanh Khê",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.894Z",
    updated_at: "2024-01-28T17:20:47.894Z",
  },
  {
    id: 492,
    name: "Hải Châu",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.907Z",
    updated_at: "2024-01-28T17:20:47.907Z",
  },
  {
    id: 493,
    name: "Sơn Trà",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.923Z",
    updated_at: "2024-01-28T17:20:47.923Z",
  },
  {
    id: 494,
    name: "Ngũ Hành Sơn",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.935Z",
    updated_at: "2024-01-28T17:20:47.935Z",
  },
  {
    id: 495,
    name: "Cẩm Lệ",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.948Z",
    updated_at: "2024-01-28T17:20:47.948Z",
  },
  {
    id: 497,
    name: "Hòa Vang",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.964Z",
    updated_at: "2024-01-28T17:20:47.964Z",
  },
  {
    id: 498,
    name: "Hoàng Sa",
    province_id: 48,
    popular: true,
    created_at: "2024-01-28T17:20:47.977Z",
    updated_at: "2024-01-28T17:20:47.977Z",
  },
];
export const LIST_RATING = [
  {
    id: 1,
    title: "Cơ sở vật chất",
    name: "infrastructure",
  },
  {
    id: 2,
    title: "Chất lượng dịch vụ",
    name: "service_quality",
  },
  {
    id: 3,
    title: "Quy trình làm việc",
    name: "procedure",
  },
  {
    id: 4,
    title: "Chăm sóc sau điều trị",
    name: "care",
  },
  {
    id: 5,
    title: "Đội ngũ bác sĩ",
    name: "doctor",
  },
  {
    id: 6,
    title: "Giá cả hợp lý",
    name: "price_reasonable",
  },
];
export const BRACES_TIME = [
  {
    label: "1 Tháng",
    value: 1,
  },
  {
    label: "3 Tháng",
    value: 3,
  },
  {
    label: "6 Tháng",
    value: 6,
  },
  {
    label: "1 Năm",
    value: 12,
  },
  {
    label: "2 Năm",
    value: 24,
  },
  ,
  {
    label: "3 Năm",
    value: 36,
  },
  ,
  {
    label: "Trên 3 Năm",
    value: 37,
  },
  {
    label: "Đã Hoàn Thành",
    value: 999,
  },
];

export const INTERACTION_IMAGE = [
  {
    object: "total_like",
    unselect: require("@/public/icon/icon-like.svg"),
    selected: require("@/public/icon/icon-thumb-up.svg"),
    emoji: "LIKE",
  },
  {
    object: "total_unlike",
    unselect: require("@/public/icon/icon-dislike.svg"),
    selected: require("@/public/icon/icon-thumb-down.svg"),
    emoji: "UNLIKE",
  },
  {
    object: "total_heart",
    unselect: require("@/public/icon/icon-heart-unselect.svg"),
    selected: require("@/public/icon/icon-heart.svg"),
    emoji: "HEART",
  },
  {
    object: "total_laugh",
    unselect: require("@/public/icon/icon-laugh-unselect.svg"),
    selected: require("@/public/icon/icon-laugh.svg"),
    emoji: "LAUGH",
  },
  {
    object: "total_cry",
    unselect: require("@/public/icon/icon-cry-unselect.svg"),
    selected: require("@/public/icon/icon-cry.svg"),
    emoji: "CRY",
  },
];

export const CATEGORY_BANNER_HOME = [
  {
    id: 147483647,
    name: "Bọc răng sứ",
    link: require("@/public/image/boc-rang-su.svg"),
  },
  {
    id: 147483649,
    name: "Niềng răng",
    link: require("@/public/image/nieng-rang-tham-my.svg"),
  },
  {
    id: 147483650,
    name: "Trồng răng",
    link: require("@/public/image/trong-rang-implant.svg"),
  },
];

export const PROVINCE = [
  {
    name: "Hà Nội",
    id: 1,
    lat: 21.0284793,
    lon: 105.8500046,
    region: "north",
    status: "filled",
  },
  {
    name: "Hà Giang",
    id: 2,
    lat: 22.802558,
    lon: 104.978449,
    region: "north",
  },
  {
    name: "Cao Bằng",
    id: 4,
    lat: 22.665575,
    lon: 106.25784,
    region: "north",
  },
  {
    name: "Bắc Kạn",
    id: 6,
    lat: 22.148512,
    lon: 105.834722,
    region: "north",
  },
  {
    name: "Tuyên Quang",
    id: 8,
    lat: 21.823811,
    lon: 105.216866,
    region: "north",
  },
  {
    name: "Lào Cai",
    id: 10,
    lat: 22.486913,
    lon: 103.970315,
    region: "north",
  },
  {
    name: "Điện Biên",
    id: 11,
    lat: 21.38602,
    lon: 103.016618,
    region: "north",
  },
  {
    name: "Lai Châu",
    id: 12,
    lat: 22.401093,
    lon: 103.471098,
    region: "north",
  },
  {
    name: "Sơn La",
    id: 14,
    lat: 21.328668,
    lon: 103.914399,
    region: "north",
  },
  {
    name: "Yên Bái",
    id: 15,
    lat: 21.72241,
    lon: 104.898348,
    region: "north",
  },
  {
    name: "Hoà Bình",
    id: 17,
    lat: 20.853889,
    lon: 105.337556,
    region: "north",
  },
  {
    name: "Thái Nguyên",
    id: 19,
    lat: 21.594915,
    lon: 105.848793,
    region: "north",
  },
  {
    name: "Lạng Sơn",
    id: 20,
    lat: 21.853708,
    lon: 106.761519,
    region: "north",
  },
  {
    name: "Quảng Ninh",
    id: 22,
    lat: 21.137422,
    lon: 107.3716531,
    region: "north",
    status: "filled",
  },
  {
    name: "Bắc Giang",
    id: 24,
    lat: 21.273279,
    lon: 106.1946,
    region: "north",
  },
  {
    name: "Phú Thọ",
    id: 25,
    lat: 21.319421,
    lon: 105.228206,
    region: "north",
  },
  {
    name: "Vĩnh Phúc",
    id: 26,
    lat: 21.363121,
    lon: 105.5821071,
    region: "north",
    status: "filled",
  },
  {
    name: "Bắc Ninh",
    id: 27,
    lat: 21.1587204,
    lon: 106.0615886,
    region: "north",
    status: "filled",
  },
  {
    name: "Hải Dương",
    id: 30,
    lat: 20.93904,
    lon: 106.333179,
    region: "north",
  },
  {
    name: "Hải Phòng",
    id: 31,
    lat: 20.807195,
    lon: 106.7395801,
    region: "north",
    status: "filled",
  },
  {
    name: "Hưng Yên",
    id: 33,
    lat: 20.646537,
    lon: 106.051134,
    region: "north",
  },
  {
    name: "Thái Bình",
    id: 34,
    lat: 20.446002,
    lon: 106.336582,
    region: "north",
  },
  {
    name: "Hà Nam",
    id: 35,
    lat: 20.583519,
    lon: 105.92299,
    region: "north",
  },
  {
    name: "Nam Định",
    id: 36,
    lat: 20.43882,
    lon: 106.162106,
    region: "north",
  },
  {
    name: "Ninh Bình",
    id: 37,
    lat: 20.250614,
    lon: 105.974454,
    region: "north",
  },
  {
    name: "Thanh Hóa",
    id: 38,
    region: "middle",
    lat: 19.810843,
    lon: 105.7798792,
  },
  {
    name: "Nghệ An",
    id: 40,
    lat: 19.233704,
    lon: 105.0890141,
    region: "middle",
    status: "filled",
  },
  {
    name: "Hà Tĩnh",
    id: 42,
    lat: 18.355382,
    lon: 105.900938,
    region: "middle",
  },
  {
    name: "Quảng Bình",
    id: 44,
    lat: 17.470835,
    lon: 106.622125,
    region: "middle",
  },
  {
    name: "Quảng Trị",
    id: 45,
    lat: 16.787238,
    lon: 106.901729,
    region: "middle",
  },
  {
    name: "Thừa Thiên Huế",
    id: 46,
    lat: 16.3150931,
    lon: 107.5376741,
    region: "middle",
    status: "filled",
  },
  {
    name: "Đà Nẵng",
    id: 48,
    lat: 16.0726671,
    lon: 108.0925761,
    region: "middle",
    status: "filled",
  },
  {
    name: "Quảng Nam",
    id: 49,
    lat: 15.573857,
    lon: 108.474112,
    region: "middle",
  },
  {
    name: "Quảng Ngãi",
    id: 51,
    lat: 15.121388,
    lon: 108.804633,
    region: "middle",
  },
  {
    name: "Bình Định",
    id: 52,
    lat: 13.782026,
    lon: 109.21946,
    region: "middle",
  },
  {
    name: "Phú Yên",
    id: 54,
    lat: 13.088186,
    lon: 109.092876,
    region: "middle",
  },
  {
    name: "Khánh Hòa",
    id: 56,
    lat: 12.258514,
    lon: 109.045158,
    region: "middle",
  },
  {
    name: "Ninh Thuận",
    id: 58,
    lat: 11.567636,
    lon: 108.990609,
    region: "middle",
  },
  {
    name: "Bình Thuận",
    id: 60,
    lat: 11.090088,
    lon: 108.072079,
    region: "middle",
  },
  {
    name: "Kon Tum",
    id: 62,
    lat: 14.35042,
    lon: 107.982337,
    region: "middle",
  },
  {
    name: "Gia Lai",
    id: 64,
    lat: 13.971199,
    lon: 108.014623,
    region: "middle",
  },
  {
    name: "Đắk Lắk",
    id: 66,
    lat: 12.666684,
    lon: 108.037951,
    region: "middle",
  },
  {
    name: "Đắk Nông",
    id: 67,
    lat: 12.112607,
    lon: 107.711234,
    region: "middle",
  },
  {
    name: "Lâm Đồng",
    id: 68,
    lat: 11.575279,
    lon: 107.837982,
    region: "middle",
  },
  {
    name: "Bình Phước",
    id: 70,
    lat: 11.721173,
    lon: 106.929374,
    region: "south",
  },
  {
    name: "Tây Ninh",
    id: 72,
    lat: 11.359056,
    lon: 106.125722,
    region: "south",
  },
  {
    name: "Bình Dương",
    id: 74,
    lat: 11.1707765,
    lon: 106.6698995,
    region: "south",
    status: "filled",
  },
  {
    name: "Đồng Nai",
    id: 75,
    lat: 10.9547167,
    lon: 107.2734235,
    region: "south",
    status: "filled",
  },
  {
    name: "Bà Rịa - Vũng Tàu",
    id: 77,
    lat: 10.541739,
    lon: 107.242997,
    region: "south",
  },
  {
    name: "Hồ Chí Minh",
    id: 79,
    lat: 10.762622,
    lon: 106.660172,
    region: "south",
    status: "filled",
  },
  {
    name: "Long An",
    id: 80,
    lat: 10.535247,
    lon: 106.404732,
    region: "south",
  },
  {
    name: "Tiền Giang",
    id: 82,
    lat: 10.358791,
    lon: 106.36528,
    region: "south",
  },
  {
    name: "Bến Tre",
    id: 83,
    lat: 10.241979,
    lon: 106.375054,
    region: "south",
  },
  {
    name: "Trà Vinh",
    id: 84,
    lat: 9.935182,
    lon: 106.34139,
    region: "south",
  },
  {
    name: "Vĩnh Long",
    id: 86,
    lat: 10.255093,
    lon: 105.9754,
    region: "south",
  },
  {
    name: "Đồng Tháp",
    id: 87,
    lat: 10.60017,
    lon: 105.760067,
    region: "south",
  },
  {
    name: "An Giang",
    id: 89,
    lat: 10.521583,
    lon: 105.125896,
    region: "south",
  },
  {
    name: "Kiên Giang",
    id: 91,
    lat: 10.015089,
    lon: 105.078899,
    region: "south",
  },
  {
    name: "Cần Thơ",
    id: 92,
    lat: 10.0451628,
    lon: 105.7468535,
    region: "south",
    status: "filled",
  },
  {
    name: "Hậu Giang",
    id: 93,
    lat: 9.784634,
    lon: 105.470319,
    region: "south",
  },
  {
    name: "Sóc Trăng",
    id: 94,
    lat: 9.603554,
    lon: 105.980209,
    region: "south",
  },
  {
    name: "Bạc Liêu",
    id: 95,
    lat: 9.285275,
    lon: 105.724729,
    region: "south",
  },
  {
    name: "Cà Mau",
    id: 96,
    lat: 9.176822,
    lon: 105.151365,
    region: "south",
  },
];
